import React, { useContext } from 'react'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import ConfirmationButton from '../component/button/ConfirmationButton'
import ConfirmationMessage from '../component/ConfirmationMessage'
import EstimatedRefund from '../component/EstimatedRefund'
import Instruction from '../component/instruction/Instruction'
import { rmaLRPage } from '../constant'
import ReturnItemDetail from '../component/ReturnItemDetail'
import { SelectedItemsContext } from '../../../Forms/RMAReturnStep/includes'
import { LRRefund, ItemDetailsWrapper, Heading2 } from '../style/LifetimeReplacementWmo.css'
import ConfirmationMessageWmo from '../component/ConfirmationMessageWmo'
import InstructionWmo from '../component/instruction/InstructionWmo'
import ConfirmationButtonWmo from '../component/button/ConfirmationButtonWmo'

const Confirmation = ({ moduleData }) => {
  const {
    isDesktop,
    item,
    returnId,
    orderDetails,
  } = { ...moduleData }

  const selectedItemsContextData = useContext(SelectedItemsContext)
  const { orderItems } = selectedItemsContextData
  const isWmoEnabled = useWmoEnabled();
  
  if(isWmoEnabled){
    return (
      <>
        { item && (
          <>
            <Heading2> Lifetime Replacement Claim Confirmation</Heading2>
             <ItemDetailsWrapper>
                <ConfirmationMessageWmo item={item} />
                 <ReturnItemDetail isDesktop={isDesktop} orderItems={orderItems} returnId={returnId} />
                <LRRefund>
                  Estimated Refund:&nbsp;
                  <span>
                    $
                    {parseFloat(item?.itemTotal).toFixed(2)}
                  </span>
                </LRRefund>
                <InstructionWmo type={rmaLRPage.confirmation} item={item} />
                <ConfirmationButtonWmo returnId={returnId} orderDetails={orderDetails} />
            </ItemDetailsWrapper> 
          </>
        )}
      </>
    )
  }
  
  return (
    <>
      <ConfirmationMessage item={item} />
      <EstimatedRefund item={item} />
      <Instruction type={rmaLRPage.confirmation} item={item} />
      <ConfirmationButton returnId={returnId} orderDetails={orderDetails} />
      <ReturnItemDetail isDesktop={isDesktop} orderItems={orderItems} returnId={returnId} />
    </>
  )
}

export default Confirmation
